export type MaritalStatus = 'SINGLE' | 'MARRIED' | 'DIVORCED' | 'SEPARATED' | 'WIDOWED' | 'COHABITING' | 'UNKNOWN'

export const mapToMaritalStatus = (maritalStatus: string | undefined): MaritalStatus => {
  switch (maritalStatus?.toLowerCase()) {
    case 'single':
      return 'SINGLE'
    case 'married':
      return 'MARRIED'
    case 'divorced':
      return 'DIVORCED'
    case 'separated':
      return 'SEPARATED'
    case 'widowed':
      return 'WIDOWED'
    case 'co-habiting':
      return 'COHABITING'
    default:
      return 'UNKNOWN'
  }
}
